import {Navigate, Route, Routes} from "react-router-dom";
import Login from "./components/pages/Login/Login";
import Dashboard from "./components/pages/Dashboard/Dashboard";
import PrivateRoute from "./utils/PrivateRoute";
import {ProvideAuth} from "./utils/FirebaseAuthContext";
import PublicRoute from "./utils/PublicRoute";
import Shelters from "./components/pages/Shelters/Shelters";
import Shelter from "./components/pages/Shelter/Shelter";
import Jobs from "./components/pages/Jobs/Jobs";
import Job from "./components/pages/Job/Job"
import MaterialHelp from "./components/pages/MaterialHelp/MaterialHelp";
import MaterialHelps from "./components/pages/MaterialHelps/MaterialHelps";

const Router = () => {
    return (
        <ProvideAuth>
            <Routes>
                <Route path="/" element={<Navigate to="/login"/>} />
                <Route
                    path="/login"
                    element={
                        <PublicRoute>
                            <Login/>
                        </PublicRoute>
                    }
                />
                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/shelters"
                    element={
                        <PrivateRoute>
                            <Shelters/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/shelter/:id"
                    element={
                        <PrivateRoute>
                            <Shelter/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/jobs"
                    element={
                        <PrivateRoute>
                            <Jobs/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/job/:id"
                    element={
                        <PrivateRoute>
                            <Job/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/material-helps"
                    element={
                        <PrivateRoute>
                            <MaterialHelps/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/material-help/:id"
                    element={
                        <PrivateRoute>
                            <MaterialHelp/>
                        </PrivateRoute>
                    }
                />
            </Routes>
        </ProvideAuth>
    );
}

export default Router;
